



import CarpsalePreviewComponent from "@/components/admin/carpsale/carpsalePreviewComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpsalePreviewPage",
  components: {
    CarpsalePreviewComponent,
  },
})
export default class CarpsalePreviewPage extends Vue {}
